// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  redirectUri:'https://bos.ch/ui', //to be configured

  // API_BASE_URL: 'https://ews-esz-emea.api.bosch.com/engineering/strategy/domain/master/urlshortenerapi/p/v0/',
  // This Modified Endpoint is used because our External Internet Clients need that:
  API_BASE_URL: 'https://ews-emea.api.bosch.com/engineering/strategy/domain/master/urlshortenerapi/p/v0/',

  API_DOMAIN_URL: 'https://bos.ch/',
  callbackUrl: "http://localhost:3000/auth/callback",
  userInfoUrl: "https://yourtestserver.com/oauth2/userinfo",
  userInfoNameField: "nameOfFullnameField",
  implicitGrantUrl: "https://yourtestserver.com/oauth2/auth?redirect_uri=__callbackUrl__&response_type=token&client_id=__clientId__&scope=__scopes__",
  clientId: '2839b914-5970-4a0e-adaa-349ae4eb7bb1',
  issuer:'https://login.microsoftonline.com/0ae51e19-07c8-4e4b-bb6d-648ee58410f4/v2.0',
  
  // Backend authentication: Bearer token via OAuth SSO
  backendAuthType: 'bearer',
  
  // Email validation: Require Microsoft Graph validation (false = skip validation, button always enabled)
  allow_non_validated_emails: false
};
